import fetch from 'cross-fetch';

export const loadFromUrl = async (url: string): Promise<string> => {
  try {
    const response = await fetch(url);
    
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const text = await response.text();
    return text;
  } catch (error) {
    console.error('Error loading CSV from URL:', error);
    throw new Error('Failed to load CSV from URL. Please check the URL and try again.');
  }
};